import React from "react";
import { connect } from "react-redux";
import { getStorage } from "../../../utils/storage";
import language from "../../../language";
import { Table } from "../../Table";
import {
  deleteBloodTestQuestionnaire,
  fetchBloodTestQuestionnaire,
} from "../../../utils/queries/bloodTest/questionnaireQuery";
import { DeleteModal, Modal } from "../../Modal";
import {
  ROLE_BLOOD_TEST_QUESTIONNAIRE,
  ROLE_CONTROL_PANEL,
} from "../../../constants/ROLES";
import NewQuestionnaire from "./NewQuestionnaire";
import { defineRole } from "../../../utils/handleAccessRoles";
import icons from "../../../constants/icons";

// eslint-disable-next-line no-unused-vars
let copyData = [];

class BloodTestQuestionnaire extends React.Component {
  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selectedData: {},
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });

    await this.getData(true);
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e?.target?.value,
      error,
    });
  }

  getData = async (isLoading, search = {}) => {
    try {
      const { page: currentPage, limit: currentLimit } = this.state;
      const { defaultLanguage } = this.props;
      const page = search.page || currentPage;
      const limit = search.limit || currentLimit;

      this.setState({ isLoading });

      const { data, count, totalRecords } = await fetchBloodTestQuestionnaire(
        defaultLanguage,
        {
          page,
          limit,
          q: search.q,
        }
      );

      this.setState({
        data: data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
        page,
        limit,
        totalRecords
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true, {
          q: this.state.search_text || undefined,
        });
      }
    );
  }

  handleRemoteSearch = async (search) => {
    this.setState({
      searching: true,
      page: 1,
    });

    await this.getData(true, {
      page: 1,
      q: search || undefined,
    });

    this.setState({
      searching: false,
    });
  };

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].question_text,
        key: "questionText",
        styles: {
          textTransform: "uppercase",
        },
        type: "link",
        onPress: (item) =>
          this.handleShowModal(
            "showFormModal",
            item?.questionText?.toUpperCase(),
            item
          ),
      },
      {
        title: language[this.props.defaultLanguage].type,
        key: "type",
      },
      {
        title: language[this.props.defaultLanguage].answer_type,
        key: "answerType",
      },
      {
        title: language[this.props.defaultLanguage].options,
        key: "options",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].required,
        key: "required",
      },
      {
        title: language[this.props.defaultLanguage].date,
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ];

    return headers;
  }

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deleteBloodTestQuestionnaire(
        this.props.defaultLanguage,
        this.state.selectedData._id
      );

      this.setState({ isDeleting: false });

      this.getData(true);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      console.log(error);
      this.setState({
        isDeleting: false,
      });
    }
  };

  render() {
    return (
      <div>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          totalRecords={this.state.totalRecords}
          addSearchButton
          searching={this.state.searching}
          handleSearch={(e) => this.onChangeText("search_text", e)}
          handlePressSearch={() =>
            this.handleRemoteSearch(this.state.search_text)
          }
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          showAdd={defineRole({
            roles: this.state.user.accessRole,
            menu: ROLE_BLOOD_TEST_QUESTIONNAIRE,
            operation: "create",
          })}
          addButtonText={language[this.props.defaultLanguage].add}
          handleAddPressed={(item) =>
            this.handleShowModal(
              "showFormModal",
              language[this.props.defaultLanguage].add
            )
          }
          actions={[
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_CONTROL_PANEL,
                operation: "createBloodTestingQuestionnaire",
              }),
              name: language[this.props.defaultLanguage].edit,
              onPress: (item) =>
                this.handleShowModal(
                  "showFormModal",
                  language[this.props.defaultLanguage].update,
                  item
                ),
              icon: icons.edit,
            },
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_CONTROL_PANEL,
                operation: "createBloodTestingQuestionnaire",
              }),
              name: language[this.props.defaultLanguage].delete,
              onPress: (item) =>
                this.handleShowModal(
                  "showDeleteModal",
                  language[this.props.defaultLanguage].delete,
                  item
                ),
              icon: icons.delete,
            },
          ]}
        />
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showFormModal")}
          show={this.state.showFormModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
        >
          <NewQuestionnaire
            handleCloseModal={this.handleCloseModal.bind(this, "showFormModal")}
            getData={this.getData.bind(this)}
            {...this.state.selectedData}
            data={this.state.data}
          />
        </Modal>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal"
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete.bind(this)}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state.selectedData._id}
            getData={this.getData.bind(this)}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(BloodTestQuestionnaire);
